export const SHOW_MORE = 'reviews.show_more';
export const PRODUCT_REVIEW = 'reviews.review';
export const PRODUCT_NO_REVIEW = 'reviews.no_review';
export const PRODUCT_REVIEWS = 'reviews.reviews';
